import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Link,
  Typography,
} from '@mui/material';
import { Link as RRLink } from 'react-router-dom';
import { useNotify, useRefresh } from 'react-admin';
import ButtonProgress from 'components/ButtonProgress';
import getAxios from '../../../getAxios';
import { RaRecord } from 'ra-core';

interface ApprovalConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  record: RaRecord;
}

const axios = getAxios();

const ApprovalConfirmDialog: React.FC<ApprovalConfirmDialogProps> = ({ open, onClose, record }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) {
    return null;
  }

  const positionName = record.position?.display_name || 'Unknown Position';
  const marketName = record.market?.display_name || 'Unknown Market';
  const marketId = record.market?.id;

  const handleApprove = async () => {
    try {
      setIsLoading(true);
      await axios.post(`/v3/admin/auto_generated_rates/${record.id}/approve`);
      notify('The rate was approved', { type: 'success' });
      refresh();
      onClose();
    } catch (e) {
      notify(`An error occurred: ${e.message}`, { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Approval</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: 1 }}>
          <Typography variant="body1">
            You are about to Approve the generated rate{' '}
            <strong>
              for {positionName} in{' '}
              {marketId ? (
                <Link
                  component={RRLink}
                  to={`/Market/${marketId}/show`}
                  onClick={(e) => e.stopPropagation()}
                  target="_blank"
                >
                  {marketName}
                </Link>
              ) : (
                marketName
              )}
              .
            </strong>
          </Typography>
          <Typography variant="body1" sx={{ marginTop: 2 }}>
            <strong>This will update this MPRS. Are you sure?</strong>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <ButtonProgress variant="contained" loading={isLoading} onClick={handleApprove}>
          Yes, Approve
        </ButtonProgress>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalConfirmDialog;
